import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

type Tone = 'error' | 'success' | 'info';

const TONES: Record<Tone, { wrapper: string; icon: ReactNode }> = {
  error: {
    wrapper: 'border-red-200 bg-red-50 text-red-800',
    icon: <AlertCircle className="size-4 shrink-0 text-red-600" aria-hidden />,
  },
  success: {
    wrapper: 'border-brand-200 bg-brand-50 text-brand-800',
    icon: <CheckCircle2 className="size-4 shrink-0 text-brand-600" aria-hidden />,
  },
  info: {
    wrapper: 'border-line bg-surface text-ink-soft',
    icon: <Info className="size-4 shrink-0 text-muted" aria-hidden />,
  },
};

export function Alert({
  tone = 'info',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn(
        'flex items-start gap-2.5 rounded-xl border px-3.5 py-3 text-sm',
        TONES[tone].wrapper,
        className,
      )}
    >
      {TONES[tone].icon}
      <div>{children}</div>
    </div>
  );
}
